import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ClipLoader from "react-spinners/ClipLoader";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import Flag from "react-world-flags";
import { languageServices } from "../apiServices/langauageServices";
import { useLanguage } from "../Context/LanguageContext";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { changeLanguage, language } = useLanguage();
  const [isOpen, setIsOpen] = useState(false); // Dropdown state

  const handleChangeLanguage = async (lng, e) => {
    e.preventDefault();
    await languageServices(lng, setLoading, changeLanguage);
    setIsOpen(false); // Close dropdown after selection
  };

  return (
    <div>
      {loading && (
        <div className="spinner-overlay">
          <ClipLoader color="#ffffff" loading={loading} size={60} />
        </div>
      )}

      {/* Language Dropdown */}
      <div className="dropdown">
        <button
          className="btn btn-light bg-transparent border-0 px-0 d-flex align-items-center"
          type="button"
          id="languageDropdown"
          data-bs-toggle="dropdown"
          aria-expanded={isOpen}
          onClick={() => setIsOpen(!isOpen)} // Toggle dropdown
          style={{
            color: "#00713D",
            fontWeight: 500,
          }}
        >
          {language.toUpperCase()} {/* Show current language (ENG/DE) */}
          {isOpen ? (
            <KeyboardArrowUp sx={{ fontSize: 24, marginLeft: 0 }} />
          ) : (
            <KeyboardArrowDown sx={{ fontSize: 24, marginLeft: 0 }} />
          )}
        </button>

        {/* Dropdown Menu */}
        <ul className="dropdown-menu" aria-labelledby="languageDropdown">
          <li>
            <button
              className="dropdown-item d-flex align-items-center justify-content-evenly px-0"
              onClick={(e) => handleChangeLanguage("en", e)}
            >
              <Flag code="GB" style={{ width: "20px", marginRight: "0px" }} />
              English
            </button>
          </li>
          <li>
            <button
              className="dropdown-item d-flex align-items-center justify-content-evenly px-0"
              onClick={(e) => handleChangeLanguage("de", e)}
            >
              <Flag code="DE" style={{ width: "20px", marginRight: "0px" }} />
              German
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
